import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckLogin, useLogout } from '@/hooks/useAuth';

const MyPage = () => {
  const navigate = useNavigate();
  const { data: userData, isLoading } = useCheckLogin();
  const logoutMutation = useLogout();

  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
  };

  if (isLoading) {
    return (
      <div className='min-h-screen bg-white flex items-center justify-center'>
        <p className='text-gray-600'>Loading...</p>
      </div>
    );
  }

  if (!userData) {
    navigate('/user/login');
    return null;
  }

  return (
    <>
      <div className='min-h-screen bg-white flex flex-col'>
        {/* Header */}
        <div className='flex h-full w-full justify-center items-center p-[20px]'>
          <p className='text-center font-semibold text-black text-sm'>
            My Page
          </p>
        </div>

        {/* User Information */}
        <div className='flex flex-col items-center justify-start flex-1 px-6 pt-36 pb-8'>
          <div className='flex flex-col items-center gap-2 mb-8'>
            <h1 className='text-3xl font-bold text-black'>
              {userData.nickname || 'User'}
            </h1>
            <p className='text-base text-gray-600'>{userData.email}</p>
          </div>

          {/* Action Buttons */}
          <div className='w-full max-w-[400px] flex flex-col gap-2'>
            <button
              onClick={() => navigate('/user/change-account')}
              className='w-full h-12 bg-[#fccb16] text-black rounded-lg font-medium text-base cursor-pointer transition-all hover:bg-[#ffd84d]'
            >
              Change account
            </button>

            <button
              onClick={handleLogout}
              disabled={logoutMutation.isPending}
              className='w-full h-12 bg-transparent border border-gray-800 text-gray-800 rounded-lg font-medium text-base cursor-pointer transition-all hover:bg-gray-50 disabled:bg-gray-200 disabled:cursor-not-allowed'
            >
              {logoutMutation.isPending ? 'Logging out...' : 'Log out'}
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default MyPage;
